import { createRouter, createWebHistory } from "vue-router";
import { Toast } from "vant"
import { Base64 } from "js-base64";
import { useRoute } from "vue-router";
const route = useRoute();
const routes = [
    {
        path: "/",
        name: "index",
        component: () => import('@/views/home/index')
    },
    {
        path: "/Ticket",
        name: "Ticket",
        component: () => import('@/views/home/components/Ticket')
    },
    {
        path: "/Pay",
        name: "Pay",
        component: () => import('@/views/home/components/Pay')
    },
    {
        path: "/PaySuccess",
        name: "PaySuccess",
        component: () => import('@/views/home/components/PaySuccess')
    },
    {
        path: "/PayCancel",
        name: "PayCancel",
        component: () => import('@/views/home/components/PayCancel')
    },
    {
        path: "/PayResult",
        name: "PayResult",
        component: () => import('@/views/home/components/PayResult')
    },
    {
        path: "/TicketList",
        name: "TicketList",
        component: () => import('@/views/home/components/TicketList')
    },
    {
        path: "/TicketUse",
        name: "TicketUse",
        component: () => import('@/views/home/components/TicketUse')
    },
    {
        path: "/UseList",
        name: "UseList",
        component: () => import('@/views/home/components/UseList')
    },
    {
        path: "/UseSuccess",
        name: "UseSuccess",
        component: () => import('@/views/home/components/UseSuccess')
    },
    {
        path: "/Notice",
        name: "Notice",
        component: () => import('@/components/readNotice/index')
    },
    {
        path: "/Login",
        name: "Login",
        component: () => import('@/views/home/components/Login')
        //component: () => import('@/views/login/login')
    },
    {
        path: "/Register",
        name: "Register",
        component: () => import('@/views/home/components/Register')
    },
    {
        path: "/Code",
        name: "Code",
        component: () => import('@/views/home/components/registerModules/code.vue')
    },
    {
        path: "/Password",
        name: "Password",
        component: () => import('@/views/home/components/registerModules/password.vue')
    },
    {
        path: "/personal",
        name: "personal",
        component: () => import('@/views/home/components/personal')
    },
    {
        path: "/storeEvaluation",
        name: "storeEvaluation",
        component: () => import('@/views/home/components/storeEvaluation')
    },
    {
        path: "/CouponIntro",
        name: "CouponIntro",
        component: () => import('@/views/home/components/CouponIntro')
    },
    {
        path: "/GoodsIntro",
        name: "GoodsIntro",
        component: () => import('@/views/home/components/GoodsIntro')
    },
    {
        path: "/statute",
        name: "statute",
        component: () => import('@/views/home/components/service/statute')
    },
    {
        path: "/policy",
        name: "policy",
        component: () => import('@/views/home/components/service/policy')
    },
    {
        path: "/CouponList",
        name: "CouponList",
        component: () => import('@/views/home/components/CouponList')
    },
    {
        path: "/CouponUse",
        name: "CouponUse",
        component: () => import('@/views/home/components/CouponUse')
    },
    {
        path: "/ScanCouponList",
        name: "ScanCouponList",
        component: () => import('@/views/home/components/ScanCouponList')
    },
    {
        path: "/ScanCouponUse",
        name: "ScanCouponUse",
        component: () => import('@/views/home/components/ScanCouponUse')
    },
    {
        path: "/Comment",
        name: "Comment",
        component: () => import('@/views/home/components/Comment')
    },
    {
        path: "/PointRecord",
        name: "PointRecord",
        component: () => import('@/views/home/PointRecord')
    },
];

const router = createRouter({
    history: createWebHistory(process.env.NODE_ENV === 'production' ? '/' : '/'),
    routes
});

router.afterEach(() => {
    //全局判断是否是微信浏览器
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("micromessenger") !== -1) {
        if (route.query.open_id == undefined) {
            var param = location.search;
            var base64Param = Base64.encode(param);
            var cur_url =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?callback=" +
                base64Param;
            window.location.href =
                "https://passport.try-see.net/login/third?url=" +
                cur_url +
                "&chl=wechat";
        } else {
            //判断本地存储有无open_id
            if(!localStorage.getItem("ticket_open_id")){
                //将open_id存入本地，同时再次刷新 解析微信浏览器返回的callback
                localStorage.setItem("ticket_open_id", route.query.open_id);
                if (route.query.callback) {
                    var ori_url = Base64.decode(route.query.callback);
                    window.location.href = window.location.protocol + "//" + window.location.host + ori_url + '&open_id=' + route.query.open_id
                }
            }
        }
    }
    Toast.clear()
})

export default router;
